import { i18n } from "@/config/i18n";

export default {
  name: "MasterPartnerProgram",
  data() {
    return {
      showCopyToast: false,
      clientCapital: 200000,
      profitShareRate: 30,
    };
  },
  computed: {
    estProfitShare() {
      return this.clientCapital * (this.profitShareRate / 100);
    },
    estBackCommission() {
      // Back-commission (spread rebate) = 1.5% of Client Capital per month
      return this.clientCapital * 0.015;
    },
    totalMonthlyIncome() {
      return this.estProfitShare + this.estBackCommission;
    },
    partnerTier() {
      const income = this.totalMonthlyIncome;
      if (income < 3000) {
        return {
          name: this.$t('blog.masterpartner.tierBronze'),
          icon: 'fas fa-medal',
          class: 'mpp__tier-badge--bronze',
          quote: this.$t('blog.masterpartner.tierBronzeQuote')
        };
      } else if (income < 10000) {
        return {
          name: this.$t('blog.masterpartner.tierSilver'),
          icon: 'fas fa-award',
          class: 'mpp__tier-badge--silver',
          quote: this.$t('blog.masterpartner.tierSilverQuote')
        };
      } else if (income < 30000) {
        return {
          name: this.$t('blog.masterpartner.tierGold'),
          icon: 'fas fa-crown',
          class: 'mpp__tier-badge--gold',
          quote: this.$t('blog.masterpartner.tierGoldQuote')
        };
      } else {
        return {
          name: this.$t('blog.masterpartner.tierLegendary'),
          icon: 'fas fa-trophy',
          class: 'mpp__tier-badge--legendary',
          quote: this.$t('blog.masterpartner.tierLegendaryQuote')
        };
      }
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    formatNumber(num) {
      return Math.round(num).toLocaleString('en-US');
    },
    copyPhone(phone) {
      const plainNum = phone.replace(/[^\d+]/g, '');
      navigator.clipboard.writeText(plainNum).catch(() => {});
      this.showCopyToast = true;
      setTimeout(() => { this.showCopyToast = false; }, 2000);
    }
  }
};
